import {EventCustomParameters} from '_types'
import {analyticsLogEvent} from '../api'

const eventName = 'custom_event'

/**
 * @name analyticsEventCustom
 *
 * @event
 *
 * @description
 * Tracks a custom event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventCustomCategory} params.category - Category of the event.
 * @param {EventCustomAction} params.action - Action of the event.
 * @param {EventCustomLabel | undefined} [params.label] - Label of the event (optional).
 * @param {string | undefined} [params.buttonType] - Type of the button (optional).
 * @param {string | undefined} [params.accessType] - Type of access (optional).
 * @param {string | undefined} [params.boutiqueName] - Name of the boutique (optional).
 * @param {string | undefined} [params.filterType] - Type of filter applied (optional).
 * @param {string | undefined} [params.filterValue] - Value of the filter applied (optional).
 * @param {string | undefined} [params.menuHierarchy] - Hierarchy of the menu (optional).
 * @param {string | undefined} [params.menuTemplate] - Template of the menu (optional).
 */
export function analyticsEventCustom({
    category,
    action,
    label,
    buttonType,
    accessType,
    boutiqueName,
    filterType,
    filterValue,
    menuHierarchy,
    menuTemplate,
}: EventCustomParameters) {
    const eventDetails = {
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        buttonType,
        accessType,
        boutiqueName,
        filterType,
        filterValue,
        menu_hierarchy: menuHierarchy,
        menu_template: menuTemplate,
    }

    // Clean undefined values from the event details object
    Object.keys(eventDetails).forEach((key) => {
        if (eventDetails[key] === undefined) {
            delete eventDetails[key]
        }
    })

    analyticsLogEvent(eventName, eventDetails)
}
